__turbopack_context__.v({
  "arrow": "BlogArticleCard-module__1MwsQa__arrow",
  "body": "BlogArticleCard-module__1MwsQa__body",
  "card": "BlogArticleCard-module__1MwsQa__card",
  "category": "BlogArticleCard-module__1MwsQa__category",
  "excerpt": "BlogArticleCard-module__1MwsQa__excerpt",
  "footer": "BlogArticleCard-module__1MwsQa__footer",
  "meta": "BlogArticleCard-module__1MwsQa__meta",
  "readMore": "BlogArticleCard-module__1MwsQa__readMore",
  "readTime": "BlogArticleCard-module__1MwsQa__readTime",
  "title": "BlogArticleCard-module__1MwsQa__title",
});
